module.exports = __webpack_public_path__ + "img/guidepage.0c26d904.png";